import styled from "@emotion/native"
import { ReactNode } from "react"
import { Keyboard, Platform } from "react-native"

type PressableContainerProps = {
  children: ReactNode
  onPress?: () => void
}

export function CloseKeyboardContainer({ children }: PressableContainerProps) {
  if (Platform.OS === "web") {
    return <WebContainer>{children}</WebContainer>
  }

  return <MobileContainer onPress={Keyboard.dismiss}>{children}</MobileContainer>
}

const MobileContainer = styled.Pressable`
  flex: 1;
  justify-content: space-between;
`

const WebContainer = styled.View`
  flex: 1;
  justify-content: space-between;
`
